import { AppRoute } from "../interfaces/AppRoute";
import Contatos from "./Contato/pages/contatos";
import DocsPoliticas from "./Empresa/pages/docs-politicas";
import Pessoas from "./Empresa/pages/pessoas";
import SobreNos from "./Empresa/pages/sobre-nos";
import FormularioLGPD from "./FormularioLGPD/pages/formulario-lgpd";
import Home from "./Home/pages/home";
import Energia from "./Servicos/pages/energia";
import Telecom from "./Servicos/pages/telecom";

export const getRoutes = (): AppRoute[] => [
  {
    title: "Home",
    path: "/",
    standalone: true,
    external: false,
    component: <Home />,
  },
  {
    title: "Sobre Nós",
    path: "/empresa/sobre-nos",
    external: false,
    standalone: false,
    component: <SobreNos />
  },
  {
    title: "Pessoas",
    path: "/empresa/pessoas",
    external: false,
    standalone: false,
    component: <Pessoas />
  },
  {
    title: "Documentos & Políticas",
    path: "/empresa/docs-politicas",
    standalone: false,
    external: false,
    component: <DocsPoliticas />
  },
  // {
  //   title: "Mídia",
  //   path: "/empresa/midia",
  //   external: false,
  //   standalone: false,
  //   component: <Midia />
  // },
  {
    title: "Telecom",
    path: "/servicos/telecom",
    external: false,
    standalone: false,
    component: <Telecom />
  },
  {
    title: "Energia",
    path: "/servicos/energia",
    external: false,
    standalone: false,
    component: <Energia />
  },
  {
    title: "Formulário para Requisição do Titular de Dados Pessoais - LGPD",
    path: "/formulario-lgpd",
    standalone: true,
    external: false,
    component: <FormularioLGPD/>
  },
  {
    title: "Contato",
    path: "/contato",
    standalone: true,
    external: false,
    component: <Contatos />
  }
];
